import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const EmailIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M1.5 3.75C1.5 3.33579 1.83579 3 2.25 3H13.75C14.1642 3 14.5 3.33579 14.5 3.75V12.25C14.5 12.6642 14.1642 13 13.75 13H2.25C1.83579 13 1.5 12.6642 1.5 12.25V3.75ZM3 4.5V11.5H13V4.5H3Z"
		></path>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M1.73223 3.23223C1.92973 3.03473 2.25131 3.03473 2.44882 3.23223L8 8.78342L13.5512 3.23223C13.7487 3.03473 14.0703 3.03473 14.2678 3.23223C14.4653 3.42974 14.4653 3.75132 14.2678 3.94882L8.35832 9.85832C8.16082 10.0558 7.83918 10.0558 7.64168 9.85832L1.73223 3.94882C1.53473 3.75132 1.53473 3.42974 1.73223 3.23223Z"
		></path>
	</svg>
))
